import { baseApi } from './baseApi';
import type { User } from '../store/slices/authSlice';

interface CompleteOnboardingRequest {
  companyName: string;
  plan: 'free' | 'starter' | 'pro';
}

interface CompleteOnboardingResponse {
  success: true;
  message: string;
  data: {
    token: string;
    user: User & {
      customerId: string;
      customer: {
        id: string;
        name: string;
        plan: string;
        subscriptionStatus: string;
      };
    };
  };
}

export const onboardingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    completeOnboarding: builder.mutation<CompleteOnboardingResponse, CompleteOnboardingRequest>({
      query: (onboardingData) => ({
        url: '/auth/onboarding',
        method: 'POST',
        body: onboardingData,
      }),
      // Only invalidate Customer initially, we'll handle the rest manually after token update
      invalidatesTags: ['Customer'],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          
          // Import auth actions here to avoid circular imports
          const { updateUserAndToken } = await import('../store/slices/authSlice');
          
          // Immediately update the token and user in Redux state
          dispatch(updateUserAndToken({ 
            user: data.data.user, 
            token: data.data.token 
          }));
          
          // Now that token is updated, invalidate the caches
          // This ensures subsequent API calls use the new token
          dispatch(baseApi.util.invalidateTags(['Lead', 'LeadStats', 'LandingPage', 'LandingPageStats']));
        } catch (error) {
          // Handle error if needed
          console.error('Onboarding completion failed:', error);
        }
      },
    }),
  }),
});

export const {
  useCompleteOnboardingMutation,
} = onboardingApi;